module.exports = __webpack_public_path__ + "img/Cartelera_utra_laplata.9761a1d4.jpg";